import EnrollmentGraphic from '../../assets/enrollment_graphic.png';
import { Row, Col } from 'antd';
import { Outlet, useNavigate } from 'react-router';
import { useSelfServiceData } from '../utils/useSelfServiceData';
import { consentNeeded, faceEnrolled, getBiometricsConsentInfo } from '../utils/helpers';
import { useEffect, useMemo } from 'react';
import { SelfServicePath } from '../SelfServiceRoutes';
import type { SelfServiceLandingPageDataResponse } from 'src/api/types';

import './styles.less';

const FaceCaptureLayout: React.FC = () => {
  const { data, isLoading } = useSelfServiceData();
  const navigate = useNavigate();
  const blockFaceCapturing = useMemo(
    () => (isLoading: boolean, data?: SelfServiceLandingPageDataResponse) => {
      const consent = getBiometricsConsentInfo(data);
      return !isLoading && (!data || !consent || (faceEnrolled(data) && !consentNeeded(consent)));
    },
    [],
  );

  useEffect(() => {
    if (blockFaceCapturing(isLoading, data)) {
      navigate(SelfServicePath.SELF_SERVICE_LANDING_PAGE);
    }
  }, [data, isLoading, navigate, blockFaceCapturing]);

  return (
    <div className="face-wrapper">
      <Row className="face-card">
        <Col xs={24} md={10} className="face-left-panel">
          <img src={EnrollmentGraphic} alt="Face graphic" className="face-graphic" />
        </Col>
        <Col xs={24} md={14} className="face-right-panel">
          <Outlet />
        </Col>
      </Row>
    </div>
  );
};

export default FaceCaptureLayout;
